import { useEffect, useState } from "react";
import { Plus, Trash2, Save } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

const EMPTY = { name: "", phone: "", email: "", zone: "", truck_type: "", status: "disponible", notes: "" };

export default function AdminDrivers() {
  const [rows, setRows] = useState([]);
  const [draft, setDraft] = useState(EMPTY);

  const load = () => api.get("/admin/drivers").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!draft.name || !draft.phone) return toast.error("Nom et téléphone requis");
    try { await api.post("/admin/drivers", draft); setDraft(EMPTY); load(); toast.success("Chauffeur ajouté"); }
    catch (e) { toast.error(formatErr(e)); }
  };
  const remove = async (id) => { if (!window.confirm("Supprimer ?")) return; try { await api.delete(`/admin/drivers/${id}`); load(); toast.success("Supprimé"); } catch (e) { toast.error(formatErr(e)); } };

  return (
    <div>
      <div className="font-heading text-3xl font-black uppercase tracking-tight">Chauffeurs</div>
      <div className="h-1 w-16 bg-brand mt-2 mb-6" />

      <div className="bg-ink-900 border border-ink-700 p-5 mb-4">
        <div className="font-heading text-lg font-bold uppercase tracking-tight mb-3">Ajouter un chauffeur</div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2">
          {["name","phone","email","zone","truck_type","notes"].map((k) => (
            <input key={k} placeholder={k} className="h-10 px-3 bg-ink-800 border border-ink-700 focus:border-brand text-white outline-none" value={draft[k]} onChange={(e) => setDraft((s) => ({ ...s, [k]: e.target.value }))} data-testid={`driver-${k}`} />
          ))}
          <select className="h-10 px-3 bg-ink-800 border border-ink-700 focus:border-brand text-white outline-none" value={draft.status} onChange={(e) => setDraft((s) => ({ ...s, status: e.target.value }))}>
            <option value="disponible">Disponible</option><option value="en_mission">En mission</option><option value="hors_ligne">Hors ligne</option>
          </select>
          <button onClick={create} className="h-10 bg-brand hover:bg-brand-600 text-white font-bold uppercase px-4 inline-flex items-center justify-center gap-2 transition-colors" data-testid="driver-add-btn"><Plus size={14} /> Ajouter</button>
        </div>
      </div>

      <div className="bg-ink-900 border border-ink-700 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-ink-800 text-zinc-400 uppercase text-xs">
            <tr><th className="text-left px-4 py-3">Nom</th><th className="text-left px-4 py-3">Téléphone</th><th className="text-left px-4 py-3">Zone</th><th className="text-left px-4 py-3">Camion</th><th className="text-left px-4 py-3">Statut</th><th></th></tr>
          </thead>
          <tbody className="divide-y divide-ink-700">
            {rows.map((d) => (
              <tr key={d.id} className="hover:bg-ink-800">
                <td className="px-4 py-3 font-semibold">{d.name}</td>
                <td className="px-4 py-3">{d.phone}</td>
                <td className="px-4 py-3">{d.zone || "—"}</td>
                <td className="px-4 py-3">{d.truck_type || "—"}</td>
                <td className="px-4 py-3"><span className="bg-ink-800 border border-ink-700 px-2 py-1 text-xs">{d.status}</span></td>
                <td className="px-4 py-3 text-right"><button onClick={() => remove(d.id)} className="text-zinc-500 hover:text-red-400"><Trash2 size={14} /></button></td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={6} className="text-center py-8 text-zinc-500">Aucun chauffeur</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
